var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"!border border-gray-100 outline-none text-md px-3 py-2 placeholder-gray-600 disabled:bg-gray-100 min-h-[7rem]",domProps:{"value":(_vm.model)},on:{"input":function($event){if($event.target.composing)return;_vm.model=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }